export default {"src":"/_next/static/media/thumb.4714b54e.svg","height":28,"width":28};